import { UserService, AuthenticationError } from '@/services/user.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
    authenticating: false,
    accessToken: TokenService.getToken(),
    userData: TokenService.getUserData(),
    authenticationErrorCode: 0,
    authenticationError: ''
}

const getters = {
    loggedIn: (state) => {
        return state.accessToken ? true : false
    },

    authenticationErrorCode: (state) => {
        return state.authenticationErrorCode
    },

    authenticationError: (state) => {
        return state.authenticationError
    },

    authenticating: (state) => {
        return state.authenticating
    },
    userData (state) {
        // console.log('user %o', state.userData)
        // return JSON.parse(state.userData)
        return state.userData
    },
    userHasSysAdminRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('systemadmin')
    },
    userHasSalesAdminRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('salesadmin')
    },
    userHasPublicRole (state) {
        return state.userData && state.userData.roles 
            && (state.userData.roles.includes('salesrep')
                || state.userData.roles.includes('salessupport'))
    },
    userHasInternalRole (state) {
        // console.log(state.userData)

        return state.userData && 
            state.userData.roles && 
            (state.userData.roles.includes('csrep') 
                || state.userData.roles.includes('insiderep')
                || state.userData.roles.includes('systemadmin')
            )
    },
    userHasSalesRepRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('salesrep')
    },
    userHasCSRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('csrep')
    },
    userHasInsideRepRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('insiderep')
    },
    userHasSalesQuoteManagerRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('salesQuoteManager')
    },
    userHasSalesSupportRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('salessupport')
    },
    userHasContractdeptRole (state) {
        return state.userData && state.userData.roles && state.userData.roles.includes('contractdept')
    },
    // 20201123, if it is local dev or internal HM network, = true
    // if it is public url site, = false
    isHMInternalSite() {
        return process.env.VUE_APP_ROOT_API == '/'
    },
}

const actions = {
    async login({ commit }, {email, password}) {
        commit('loginRequest');

        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const token = await UserService.login(email, password);
            commit('loginSuccess', token)

            // Redirect the user to the page he first tried to visit or to the home view
            // router.push(router.history.current.query.redirect || '/');

            return true
        } catch (e) {
            if (e instanceof AuthenticationError) {
                // console.log(e)
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
            }

            return false
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

    logout({ commit }) {
        UserService.logout()
        commit('logoutSuccess')
        router.push('/login')
    }
}

const mutations = {
    loginRequest(state) {
        state.authenticating = true;
        state.authenticationError = ''
        state.authenticationErrorCode = 0
    },

    loginSuccess(state, accessToken) {
        state.accessToken = accessToken
        state.authenticating = false;
        state.userData = TokenService.getUserData()
    },

    loginError(state, {errorCode, errorMessage}) {
        state.authenticating = false
        state.authenticationErrorCode = errorCode
        state.authenticationError = errorMessage
    },

    logoutSuccess(state) {
        state.accessToken = ''
        state.userData = ''
    }
}

export const auth = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}